import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import { interceptRequest } from '@common/js/http'
import { getAcceptLanguage, toAcceptLanguage } from './common'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 设置超时时间
axios.defaults.timeout = 60 * 1000

const NESTED_HEADER_KEYS = ['delete', 'get', 'head', 'post', 'put', 'patch', 'common']

function assignFlatHeaders(target, source) {
  if (!source) return
  Object.keys(source).forEach(key => {
    if (NESTED_HEADER_KEYS.indexOf(key) !== -1) return
    const val = source[key]
    if (val != null && typeof val !== 'object') {
      target[key] = val
    }
  })
}

// axios 0.18 会把 common / method 嵌套 header 再合并一次；拦截器里先展平，保证 Accept-Language 一定是字符串 header
function applyAcceptLanguage(config) {
  const lang = getAcceptLanguage()
  const method = (config.method || 'get').toLowerCase()
  const headers = config.headers || {}
  const flat = {}
  assignFlatHeaders(flat, headers.common)
  assignFlatHeaders(flat, headers[method])
  assignFlatHeaders(flat, headers)
  flat['Accept-Language'] = lang
  config.headers = flat
  return config
}

export function syncAcceptLanguageHeader(locale) {
  axios.defaults.headers.common['Accept-Language'] = locale
    ? toAcceptLanguage(locale)
    : getAcceptLanguage()
}

syncAcceptLanguageHeader()

// 拦截请求，修改请求的配置
axios.interceptors.request.use(
  config => {
    config = interceptRequest(config, Qs)
    return applyAcceptLanguage(config)
  },
  error => {
    return Promise.reject(error)
  }
)

// 拦截响应
axios.interceptors.response.use(response => {
  let data = response.data
  let code = data.c
  switch (code) {
    // 请求成功
    case 0:
      return data.d
    case -3: // 没有权限
    case -6: // 登录过期
    case -4:
      let pathname = window.location.pathname
      if(pathname.indexOf('/en-us/login') > -1 || pathname.indexOf('/en-us/register') > -1 || 
        pathname.indexOf('/zh-cn/login') > -1 || pathname.indexOf('/zh-cn/register') > -1){
        return Promise.reject(data)
      }
      Vue.prototype.Login()
      return Promise.reject(data)
    case -5:
      return Promise.reject(data)
    default:
      return Promise.reject(data)
  }
})

Object.defineProperties(Vue.prototype, {
  $http: {
    get() {
      return axios
    },
  },
})

export { axios as $http }
